import { BaseViewHTML } from '../../../systems/base-view-html.js';

export class SubtitleViewHTML extends BaseViewHTML {
  private text: string = '';
  private isVisible: boolean = false;

  constructor(processId: string) {
    super(processId, `${processId}-subtitles`, {
      preferredSize: { width: 600, height: 100 },
      showDismissButton: false,
      priority: 1000 // Top priority
    });
    
    // Override default geometry to be bottom center
    this.geometry = {
        x: (window.innerWidth - 600) / 2,
        y: window.innerHeight - 150,
        width: 600,
        height: 100
    };
  }

  setText(text: string) {
    this.text = text;
    this.isVisible = !!text;
    this.render();
  }

  protected getContentHTML(): string {
    if (!this.isVisible) return '';

    return `
      <div style="
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        padding: 16px;
        background: rgba(0, 0, 0, 0.7);
        border-radius: 12px;
        backdrop-filter: blur(10px);
        color: white;
        font-family: 'Inter', sans-serif;
        font-size: 18px;
        font-weight: 500;
        text-align: center;
        opacity: ${this.isVisible ? 1 : 0};
        transition: opacity 0.3s ease;
        pointer-events: none; /* Let clicks pass through */
      ">
        ${this.text}
      </div>
    `;
  }
  
  // Override render to update position on resize if needed
  protected render(): void {
      if (this.element) {
          this.element.innerHTML = this.getContentHTML();
          
          // Ensure it stays centered
          this.element.style.left = `${(window.innerWidth - 600) / 2}px`;
          this.element.style.top = `${window.innerHeight - 150}px`;
          // Ensure it's on top
          this.element.style.zIndex = '9999';
          this.element.style.pointerEvents = 'none';
          this.element.style.background = 'transparent';
          this.element.style.border = 'none';
      }
  }
}

